
export default {
  name: 'AppReviewVideo',
  props: {
    src: {
      type: String,
      default: null
    },
    videoWidth: {
      type: Number,
      default: 0
    },
    videoHeight: {
      type: Number,
      default: 0
    },
    thumbnailSrc: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    videoEagerLoading: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Number,
      default: 4
    },
    frame: {
      type: String,
      default: 'rounded',
      validator: v => ['sharp', 'rounded', 'circle'].includes(v)
    },
    shape: {
      type: String,
      default: 'square',
      validator: v => ['original', 'square', 'vertical'].includes(v)
    }
  },
  data() {
    return {
      lazyLoadObserver: null,
      playPauseObserver: null
    };
  },
  computed: {
    styleProp() {
      let currentBorderRadius;
      switch (this.frame) {
        case 'rounded':
          currentBorderRadius = `${this.borderRadius}px`;
          break;
        case 'circle':
          currentBorderRadius = '100%';
          break;
        default:
          currentBorderRadius = '0';
      }
      return { '--border-radius': currentBorderRadius };
    }
  },
  mounted() {
    if (!this.videoEagerLoading && this.autoPlay && !!this.src) {
      this.lazyLoadObserver = new IntersectionObserver(
        this.onIntersectForLazyLoading,
        {
          root: null
        }
      );
      this.playPauseObserver = new IntersectionObserver(
        this.onIntersectForPlayPause,
        {
          root: null
        }
      );
      this.doAutoplay(this.$refs.autoplay_video.$el);
    }
  },
  beforeDestroy() {
    this.lazyLoadObserver?.disconnect();
    this.playPauseObserver?.disconnect();
  },
  methods: {
    imageVersion(width, height) {
      if (width === 0 && height === 0) return '';
      else if (width >= height) return 'landscape';
      else return 'portrait';
    },
    doAutoplay(video) {
      if (video.readyState === HTMLMediaElement.HAVE_NOTHING) {
        this.lazyLoadObserver.observe(video);
        this.playOnCanplaythrough(video);
      }
    },
    playOnCanplaythrough(video) {
      const playPauseObserver = this.playPauseObserver;
      const onCanplaythrough = () => {
        if (
          video.readyState === HTMLMediaElement.HAVE_ENOUGH_DATA &&
          video.paused
        ) {
          playPauseObserver.observe(video);
          video.removeEventListener('canplaythrough', onCanplaythrough);
        }
      };
      video.addEventListener('canplaythrough', onCanplaythrough);
    },
    onIntersectForLazyLoading(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          video.src = this.src;
          video.load();
          observer.disconnect();
        }
      });
    },
    onIntersectForPlayPause(entries, _observer) {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
};
